import { PaddingType } from 'common/types/styleTypes'
import { mobileTextCss, TextProps, textCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type BaseTextEntityUiProps = {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
} & TextProps

const BaseTextEntityUi = styled.p<BaseTextEntityUiProps>`
  ${textCss}
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
    `}
`

export default BaseTextEntityUi
